import { Component, input, output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lib-nav-dropdown',
  template: `
    <div class="relative dropdown-container">
      <button
        (click)="onClick($event)"
        class="flex items-center space-x-1 text-gray-200 hover:text-orange-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 focus:ring-offset-gray-900 rounded-md px-3 py-2 text-sm font-medium transition-colors duration-200"
      >
        <span>{{ label() }}</span>
        <svg
          class="w-4 h-4 transition-transform duration-200"
          [class.rotate-180]="isOpen()"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      @if (isOpen()) {
        <div
          [class]="'absolute right-0 mt-2 ' + panelWidth() + ' bg-gray-800 rounded-lg shadow-xl border border-gray-700 z-[60]'"
        >
          <ng-content />
        </div>
      }
    </div>
  `,
})
export class NavDropdownComponent {
  label = input.required<string>();
  isOpen = input.required<boolean>();
  panelWidth = input<string>('w-64');

  toggleClicked = output<void>();

  onClick(event: MouseEvent): void {
    event.stopPropagation();
    this.toggleClicked.emit();
  }
}
